import { _hub_exp_thisTask } from '../components/hub'

export class NodeTree {
  constructor(nodes = null, words = null) {
    if (nodes) this.constructFromNodes(nodes)
    else this.constructFromWords(words)
  }

  findWordNode(order) {
    return this.rootNode.findWordNode(order)
  }

  constructFromNodes(nodes, totalLength) {
    this.rootNode = new Node(
      {
        word: null,
        level: 0,
        parent: null,
        root: this.rootNode,
        lastNodeOrder: totalLength - 1,
      },
      [0, totalLength - 1],
      totalLength
    )
    for (let root of nodes)
      this.rootNode.addChild(
        this._getChildFromNode(
          root.children[0],
          1,
          this.rootNode,
          this.rootNode,
          totalLength - 1
        )
      )
    this._getOrdersFromChildren(0, this.rootNode.children)
  }

  constructFromWords(textArray) {
    this.rootNode = new Node(
      {
        word: null,
        level: 0,
        parent: null,
        root: this.rootNode,
        lastNodeOrder: textArray.length - 1,
      },
      [0, textArray.length - 1],
      textArray.length
    )
    for (let textInd in textArray)
      this.rootNode.addChild(
        new Node(
          {
            word: textArray[textInd][0],
            level: 1,
            parent: this.rootNode,
            root: this.rootNode,
            lastNodeOrder: textArray.length - 1,
          },
          Number(textInd),
          1
        )
      )
  }

  _getChildFromNode(node, level, parent, root, lastNodeOrder) {
    const childNode = new Node({
      word: null,
      level: level,
      parent: parent,
      root: root,
      lastNodeOrder: lastNodeOrder,
    })

    if (node.children && node.children.length) {
      for (let child of node.children)
        childNode.addChild(
          this._getChildFromNode(
            child,
            level + 1,
            childNode,
            root,
            lastNodeOrder
          )
        )
    } else {
      childNode.word = node.word
    }

    return childNode
  }

  _getOrdersFromChildren(start, children) {
    let current = start
    for (let child of children) {
      if (!child.children) {
        child.order = current
        child.length = 1
        current++
      } else {
        const childrenLength = this._getOrdersFromChildren(
          current,
          child.children
        )
        child.order = [current, current + childrenLength - 1]
        child.length = childrenLength
        current += childrenLength
      }
    }

    return current - start
  }
}

class Node {
  constructor(
    { word, level, parent, root, lastNodeOrder },
    order = null,
    length = null
  ) {
    this.children = null
    this.word = word
    this.level = level
    this.parent = parent
    this.root = root

    this.firstNodeOrder = 0
    this.lastNodeOrder = lastNodeOrder

    this.order = order
    this.length = length
  }

  addChild(child) {
    if (!this.children) this.children = []
    this.children.push(child)
  }

  findWordNode(order) {
    if (this.order.length && this.order[0] <= order && this.order[1] >= order) {
      for (let child of this.children) {
        const found = child.findWordNode(order)
        if (found) return found
      }
      return null
    } else if (this.order === order) {
      return this
    }
  }

  sameParentNextChild(direction, aggressive = 1, originalOrder = null) {
    // reached the end of the paragraph
    let nextOrder = this.getNextOrderNumber(direction)
    if (nextOrder === this.order) return null

    originalOrder = originalOrder || this.order

    let parentToSearch = this.parent
    let findParentLevel = 1
    while (
      parentToSearch &&
      this._onParentEndOfDirection(parentToSearch, direction)
    ) {
      parentToSearch = parentToSearch.parent
      findParentLevel++
    }

    /* -------------------------------------------------------------------------- */

    // let nextChild
    // nextChild = parentToSearch.children[0]
    // for (let i = 1; i < findParentLevel; i++) {
    //   nextChild = nextChild.children[0]
    // }

    /* -------------------------------------------------------------------------- */

    for (let child of parentToSearch.children) {
      if (
        child.order === nextOrder ||
        (child.order.length &&
          child.order[direction === 1 ? 0 : 1] === nextOrder)
      ) {
        const targetOrder = child.order.length
          ? child.order[direction === 1 ? 1 : 0]
          : child.order
        const targetChildNode = this.root.findWordNode(targetOrder)
        if (aggressive && Math.abs(targetOrder - originalOrder) <= aggressive)
          return targetChildNode.sameParentNextChild(
            direction,
            aggressive,
            originalOrder
          )
        else return targetOrder
      }
    }
  }

  _onParentEndOfDirection(parent, direction) {
    return (
      (direction === -1 && this.order === parent.order[0]) ||
      (direction === 1 && this.order === parent.order[1])
    )
  }

  getNextOrderNumber(direction) {
    return Math.max(
      Math.min(this.order + direction, this.lastNodeOrder),
      this.firstNodeOrder
    )
  }
}
